import { render, staticRenderFns } from "./RedirectURL.vue?vue&type=template&id=38a4235a&scoped=true&"
import script from "./RedirectURL.vue?vue&type=script&lang=js&"
export * from "./RedirectURL.vue?vue&type=script&lang=js&"
import style0 from "./RedirectURL.vue?vue&type=style&index=0&id=38a4235a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a4235a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38a4235a')) {
      api.createRecord('38a4235a', component.options)
    } else {
      api.reload('38a4235a', component.options)
    }
    module.hot.accept("./RedirectURL.vue?vue&type=template&id=38a4235a&scoped=true&", function () {
      api.rerender('38a4235a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/game/sunset-drive/components/RedirectURL.vue"
export default component.exports